<div class="root">
    <div class="loader">
        <span class="outer icon-loader"></span>
        <span class="inner icon-loader"></span>
    </div>
</div>

<style>
    .root {
        position: relative;
        background-color: var(--loader-bg-color, transparent);
        color: var(--loader-fg-color, #FFF);
        text-shadow: var(--loader-text-shadow, 0 0 5px #227FFF, 0 0 10px #227FFF);
    }

    .loader {
        display: grid;
        grid-template-rows: 1fr;
        grid-template-columns: 1fr;
        grid-template-areas: "loader";
        align-items: center;
        justify-content: center;
        text-align: center;
    }

    .loader > span {
        grid-area: loader;
        font-weight: bold;
        animation-duration: 0.75s;
        animation-iteration-count: infinite;
        animation-timing-function: cubic-bezier(.62,-0.44,.37,1.51);
        will-change: transform;
    }

    .loader > .outer {
        font-size: 70px;
        animation-name: outer-loader;
    }

    .loader > .inner {
        font-size: 40px;
        animation-name: inner-loader;
        animation-direction: reverse;
    }

    @keyframes outer-loader {
        from {
            transform: rotate(0deg);
        }

        to {
            transform: rotate(180deg);
        }
    }

    @keyframes inner-loader {
        from {
            transform: scaleX(-1) rotate(180deg);
        }

        to {
            transform: scaleX(-1) rotate(0deg);
        }
    }
</style>
